import { isNil } from 'lodash-es';

// eslint-disable-next-line import/prefer-default-export
export function getCount(count: number | undefined) {
  if (isNil(count)) {
    return 0;
  }

  if (count !== 10000) {
    return count;
  }

  return '10000+';
}
